{
  "common": {
    "loading": "Chargement...",
    "cancel": "Annuler",
    "save": "Sauvegarder",
    "save_changes": "Enregistrer les modifications",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "submit": "Soumettre",
    "saving": "Économie...",
    "sending": "Envoi...",
    "error": "Erreur",
    "success": "Succès",
    "warning": "Avertissement",
    "note": "Note",
    "no_data": "Aucune donnée",
    "yes": "Oui",
    "no": "Non",
    "back": "Dos",
    "next": "Suivant",
    "previous": "Précédent",
    "search": "Recherche",
    "filter": "Filtre",
    "all": "Tous",
    "none": "Aucun",
    "select": "Sélectionner",
    "required": "Requis",
    "optional": "Facultatif",
    "actions": "Actes",
    "status": "Statut",
    "date": "Date",
    "time": "Temps",
    "name": "Nom",
    "email": "E-mail",
    "confirm": "Confirmer",
    "add": "Ajouter",
    "done": "Terminé",
    "unknown": "Inconnu",
    "days": "jours",
    "to": "à"
  },
  "time": {
    "day": "jour",
    "days": "jours",
    "hour": "heure",
    "hours": "heures",
    "week": "semaine",
    "weeks": "semaines",
    "month": "mois",
    "months": "mois",
    "year": "année",
    "years": "années",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "yesterday": "Hier"
  },
  "status": {
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "cancelled": "Annulé",
    "active": "Actif",
    "inactive": "Inactif",
    "deleted": "Supprimé",
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "available": "Disponible",
    "coming_soon": "À venir"
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "planner": "Planificateur",
    "team": "Équipe",
    "requests": "Demandes",
    "calendar": "Calendrier",
    "settings": "Paramètres",
    "audit_trail": "Piste d'audit",
    "billing": "Facturation",
    "help": "Aide",
    "help_center": "Centre d'aide",
    "profile": "Profil",
    "my_balances": "Mes soldes",
    "leave_history": "Historique des congés",
    "restart_tour": "Redémarrer le tour",
    "logout": "Se déconnecter",
    "upgrade": "Passez à la version Pro",
    "upgrade_subtitle": "Débloquer toutes les fonctionnalités",
    "view_plans": "Consulter les plans"
  },
  "header": {
    "profile_settings": "Paramètres du profil",
    "my_profile": "Mon profil",
    "workspace": "Espace de travail",
    "leave_balances": "Solde des congés",
    "no_balances": "Aucun solde de congés trouvé."
  },
  "balance": {
    "unlimited": "Illimité",
    "days_left": "jours restants",
    "used": "utilisé",
    "remaining": "restant",
    "of": "de"
  },
  "trial": {
    "ends_today": "Votre période d'essai se termine aujourd'hui !",
    "ends_tomorrow": "Votre période d'essai se termine demain !",
    "ends_in_days": "Le procès se termine dans {days} jours.",
    "upgrade_now": "Mettez à niveau maintenant"
  },
  "feature_locked": {
    "title": "{feature} n'est pas disponible dans votre forfait.",
    "description": "Passez à un forfait supérieur pour débloquer cette fonctionnalité et bien plus encore.",
    "button": "Consulter les plans"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "out_today": "Sortie aujourd'hui",
    "out_on_date": "Sortie le {date}",
    "no_absences": "Aucune absence",
    "upcoming": "Absences à venir",
    "upcoming_empty": "Aucune absence prévue cette semaine",
    "my_balance": "Mon solde de congés",
    "my_balances": "Mes soldes",
    "no_balance_data": "Aucune donnée de solde",
    "next_holiday": "Prochain jour férié",
    "no_holidays": "Aucun jour férié à venir",
    "next_vacation": "Mes prochaines vacances",
    "nothing_booked": "Rien de réservé !",
    "upcoming_birthdays": "Anniversaires à venir",
    "no_birthdays": "Aucun anniversaire à venir",
    "birthday_today": "Aujourd'hui!",
    "birthday_in_days": "dans {days} {unit}",
    "everyone_in_office": "Tout le monde est au bureau aujourd'hui",
    "request_leave": "Demande de congé",
    "view_calendar": "Consulter le calendrier",
    "view_planner": "Planificateur de vues",
    "contact_support": "Contacter l'assistance"
  },
  "support": {
    "title": "Contacter l'assistance",
    "success_title": "Message envoyé !",
    "success_message": "Nous vous répondrons dès que possible.",
    "intro": "Besoin d'aide ? Envoyez-nous un message et nous vous répondrons rapidement.",
    "subject_label": "Sujet",
    "subject_placeholder": "Brève description de votre problème",
    "message_label": "Message",
    "message_placeholder": "Veuillez décrire votre problème ou votre question en détail...",
    "send_button": "Envoyer un message"
  },
  "requests": {
    "page_title": "Demandes de congé",
    "page_subtitle": "Examiner et gérer les demandes de congés",
    "new_request": "Demande de congé",
    "unpaid_confirm": "Seules {paid} {unit} de cette demande sont couvertes par votre solde payé. Les {unpaid} {unit} restantes seront prises en congé sans solde. Envoyer quand même ?",
    "filter": {
      "pending": "En attente",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "all": "Tous",
      "all_employees": "Tous les employés"
    },
    "table": {
      "employee": "Employé",
      "type": "Taper",
      "dates": "Dates",
      "duration": "Durée",
      "status": "Statut",
      "reason": "Raison",
      "actions": "Actes"
    },
    "action": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "cancel": "Annuler"
    },
    "empty": {
      "title": "Aucune requête trouvée",
      "pending": "Aucune demande de révision en attente.",
      "filtered": "Aucune demande de congé ne correspond à vos critères de filtrage."
    },
    "modal": {
      "reject_title": "Demande de rejet",
      "reason_label": "Motif du rejet",
      "reason_placeholder": "Motif de la demande de congé...",
      "reject_button": "Rejeter",
      "request_title": "Demande de congé",
      "employee_label": "Employé",
      "leave_type_label": "Type de congé",
      "start_date_label": "Date de début",
      "end_date_label": "Date de fin",
      "start_time_label": "Heure de début",
      "end_time_label": "Fin des temps",
      "reason_optional": "Raison (facultatif)",
      "submit_button": "Soumettre une demande",
      "submitting": "Soumission...",
      "minimum_duration": "Minimum: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Calendrier de l'équipe",
    "page_subtitle": "Consultez les absences de l'équipe et les congés planifiés.",
    "filters": {
      "button": "Filtres"
    },
    "sync": {
      "title": "Synchronisez votre calendrier",
      "description": "Connectez votre calendrier personnel pour synchroniser automatiquement les congés approuvés."
    },
    "connect": {
      "google": "Google Agenda",
      "microsoft": "Calendrier Microsoft"
    },
    "action": {
      "disconnect": "Déconnecter",
      "sync_my_leave": "Synchroniser mon congé",
      "sync_team_leave": "Congé de l'équipe Sync"
    },
    "connecting": "De liaison...",
    "syncing": "Synchronisation en cours...",
    "autosync": {
      "title": "L'équipe de synchronisation automatique part",
      "description": "Ajoutez automatiquement les congés approuvés des membres de votre équipe à votre calendrier."
    },
    "filter": {
      "department_label": "Département",
      "all_departments": "Tous les départements",
      "location_label": "Emplacement",
      "all_locations": "Tous les emplacements",
      "leave_type_label": "Type de congé",
      "all_types": "Tous types",
      "status_label": "Statut",
      "all_status": "Tous les statuts"
    },
    "nav": {
      "today": "Aujourd'hui"
    },
    "view": {
      "day": "Jour",
      "week": "Semaine",
      "month": "Mois"
    },
    "legend": {
      "pending": "En attente",
      "holiday": "Vacances"
    },
    "day_view": {
      "empty": "Pas de feuilles ce jour-là"
    },
    "more": "+{count} plus"
  },
  "team": {
    "page_title": "Équipe",
    "page_subtitle": "Gérer les membres de votre équipe",
    "tab": {
      "active": "Actifs",
      "inactive": "Inactifs",
      "deleted": "Supprimés"
    },
    "add_user": "Ajouter un utilisateur",
    "import_from_slack": "Importer depuis Slack",
    "search_placeholder": "Rechercher des membres de l'équipe...",
    "showing_results": "Affichage de {showing} sur {total} membres {status}",
    "table": {
      "name": "Nom",
      "email": "E-mail",
      "department": "Département",
      "role": "Rôle",
      "status": "Statut",
      "actions": "Actions"
    },
    "filter": {
      "search_placeholder": "Rechercher des membres de l'équipe...",
      "all_departments": "Tous les départements",
      "all_locations": "Tous les emplacements",
      "all_roles": "Tous les rôles"
    },
    "role": {
      "owner": "Propriétaire",
      "admin": "Administrateur",
      "approver": "Approbateur",
      "employee": "Employé",
      "user": "Utilisateur"
    },
    "card": {
      "no_email": "Pas d'e-mail",
      "no_department": "Pas de département",
      "no_location": "Pas d'emplacement",
      "reports_to": "Rapporte à",
      "leave_balances": "Soldes de congés"
    },
    "action": {
      "bulk_import": "Importation en masse",
      "invite_member": "Inviter un membre",
      "edit": "Modifier",
      "toil": "TOIL",
      "instances": "Instances",
      "deactivate": "Désactiver",
      "remove": "Supprimer",
      "activate": "Activer",
      "delete": "Supprimer",
      "restore": "Restaurer",
      "permanent_delete": "Supprimer définitivement"
    },
    "empty": {
      "active_title": "Aucun membre actif trouvé",
      "active_description": "Invitez des membres de l'équipe pour commencer",
      "inactive_title": "Aucun membre inactif trouvé",
      "inactive_description": "Aucun utilisateur désactivé",
      "deleted_title": "Aucun membre supprimé trouvé",
      "deleted_description": "Aucun utilisateur supprimé",
      "adjust_filters": "Essayez d'ajuster vos filtres"
    },
    "modal": {
      "edit_title": "Modifier le membre de l'équipe",
      "role": "Rôle",
      "owner_role_locked": "Le rôle du propriétaire de l'espace de travail ne peut pas être modifié",
      "department": "Département",
      "no_department": "Pas de département",
      "location": "Emplacement",
      "no_location": "Pas d'emplacement",
      "holiday_location": "Emplacement des jours fériés",
      "use_assigned_location": "Utiliser l'emplacement attribué",
      "holiday_location_help": "Remplacer les jours fériés du pays qui s'appliquent à cet utilisateur",
      "manager": "Manager",
      "no_manager": "Pas de manager",
      "start_date": "Date de début",
      "birthday": "Anniversaire",
      "birthday_help": "Utilisé pour les notifications d'anniversaire",
      "city": "Ville (pour la météo)",
      "city_placeholder": "ex., Paris, Lyon, Marseille",
      "city_help": "Remplacer la ville de l'emplacement pour une météo personnalisée. Laisser vide pour utiliser la valeur par défaut.",
      "custom_working_days": "Jours de travail personnalisés",
      "custom_working_days_help": "Remplacer les jours de travail par défaut du département pour cet utilisateur (ex., horaire à temps partiel)",
      "working_days": "Jours de travail",
      "working_days_help": "Sélectionnez les jours travaillés par cet employé (les demandes de congé ne compteront que ces jours)"
    },
    "toil": {
      "title": "Gérer le TOIL",
      "subtitle": "Repos compensateur (TOIL)",
      "current_balance": "Solde TOIL actuel",
      "available": "disponible",
      "granted": "accordé",
      "used": "utilisé",
      "hours_to_add": "Heures à ajouter",
      "hours_placeholder": "ex., 4 ou 8",
      "hours_help": "8 heures = 1 jour de TOIL",
      "reason": "Raison",
      "reason_placeholder": "ex., Travaillé samedi pour le lancement du site",
      "note": "Les heures TOIL sont ajoutées au solde de vacances de l'utilisateur mais suivies séparément. Le TOIL n'est PAS reporté à l'année suivante.",
      "adding": "Ajout en cours...",
      "add_hours": "Ajouter des heures TOIL"
    },
    "invite": {
      "title": "Ajouter un membre de l'équipe",
      "description": "Recherchez des membres Slack qui n'ont pas encore été ajoutés au suivi des vacances. Cela inclut les membres invités (invités monocanal et multicanaux).",
      "search_placeholder": "Rechercher par nom ou e-mail...",
      "searching": "Recherche des utilisateurs Slack...",
      "no_results": "Aucun utilisateur Slack correspondant trouvé",
      "all_added": "Tous les utilisateurs Slack ont déjà été ajoutés",
      "single_channel_guest": "Invité monocanal",
      "multi_channel_guest": "Invité multicanaux",
      "adding": "Ajout en cours..."
    },
    "bulk": {
      "title": "Importation en masse depuis Slack",
      "description": "Importez des membres de l'équipe depuis votre espace de travail Slack. Choisissez les types de membres à inclure.",
      "loading": "Chargement de l'espace de travail Slack...",
      "workspace_members": "Membres de l'espace de travail Slack",
      "full_members": "Membres complets",
      "multi_channel_guests": "Invités multicanaux",
      "single_channel_guests": "Invités monocanal",
      "already_imported": "Déjà importés : {count} utilisateurs",
      "who_to_import": "Qui voulez-vous importer ?",
      "all_members": "Tous les membres ({count})",
      "all_members_desc": "Membres complets + tous les types d'invités",
      "full_and_multi": "Membres complets + invités multicanaux ({count})",
      "full_and_multi_desc": "Exclut les invités monocanal",
      "full_only": "Membres complets uniquement ({count})",
      "full_only_desc": "Exclut tous les types d'invités",
      "import_complete": "Importation terminée !",
      "import_result": "{created} nouveaux utilisateurs importés, {updated} utilisateurs existants mis à jour",
      "load_failed": "Échec du chargement des données de l'espace de travail Slack",
      "importing": "Importation en cours...",
      "import_users": "Importer {count} utilisateurs"
    },
    "instances": {
      "title": "Instances de congés",
      "subtitle": "Instances de congés par événement (maternité, paternité, etc.)",
      "loading": "Chargement des instances...",
      "active": "Instances actives",
      "new_instance": "+ Nouvelle instance",
      "leave_type": "Type de congé",
      "select_leave_type": "Sélectionner le type de congé...",
      "name": "Nom (optionnel)",
      "name_placeholder": "ex., Bébé #1, Sabbatique 2025",
      "start_date": "Date de début",
      "entitlement": "Droit",
      "entitlement_placeholder": "ex., 18",
      "creating": "Création en cours...",
      "create": "Créer une instance",
      "no_active": "Aucune instance active",
      "remaining": "{remaining} sur {total} {unit} restants",
      "started": "Commencé le {date}",
      "mark_complete": "Marquer comme terminé",
      "complete": "Terminer",
      "past": "Instances passées",
      "used": "Utilisé {used} sur {total} {unit}",
      "closed": "Fermé le {date}",
      "status_completed": "terminé",
      "status_cancelled": "annulé"
    },
    "confirm": {
      "deactivate": "Êtes-vous sûr de vouloir désactiver cet utilisateur ?",
      "delete": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Il sera déplacé dans l'onglet Supprimés.",
      "permanent_delete": "Êtes-vous sûr de vouloir SUPPRIMER DÉFINITIVEMENT {name} ?",
      "permanent_delete_warning": "Cette action ne peut pas être annulée. Tout l'historique de congés et les soldes seront supprimés.",
      "permanent_delete_final": "C'est définitif ! Cliquez sur OK pour confirmer la suppression définitive."
    },
    "error": {
      "deactivate": "Échec de la désactivation de l'utilisateur",
      "activate": "Échec de l'activation de l'utilisateur",
      "delete": "Échec de la suppression de l'utilisateur",
      "restore": "Échec de la restauration de l'utilisateur",
      "permanent_delete": "Échec de la suppression définitive de l'utilisateur"
    }
  },
  "settings": {
    "page_title": "Paramètres",
    "page_subtitle": "Configurez les paramètres et les politiques de votre espace de travail",
    "access_denied": {
      "title": "Accès administrateur requis",
      "message": "Vous devez disposer des droits d'administrateur pour accéder aux paramètres."
    },
    "tab": {
      "workspace": "Espace de travail",
      "departments": "Départements",
      "locations": "Lieux",
      "holidays": "Vacances",
      "compliance": "Conformité",
      "balances": "Soldes d'ouverture",
      "notifications": "Notifications",
      "integrations": "Intégrations",
      "import": "Importer",
      "data_management": "Gestion des données",
      "locked_tooltip": "Passez à la version supérieure pour débloquer cette fonctionnalité"
    },
    "workspace": {
      "title": "Paramètres de l'espace de travail",
      "name_label": "Nom de l'espace de travail",
      "visibility_label": "Laisser la visibilité",
      "visibility": {
        "all": "Tout le monde peut voir tous les départs",
        "department": "Voir uniquement son propre département",
        "approvers": "Seuls les approbateurs peuvent tout voir"
      },
      "save_button": "Enregistrer les modifications"
    },
    "departments": {
      "title": "Départements",
      "subtitle": "Organisez votre équipe en départements dotés de politiques personnalisées.",
      "add_button": "Ajouter un département",
      "name_label": "Nom du département",
      "working_days_label": "Jours ouvrables",
      "hours_per_day_label": "Heures par jour",
      "approvers_label": "Approbateurs",
      "notification_channel_label": "Canal de notification",
      "policies_button": "Gérer les politiques",
      "edit_button": "Modifier",
      "delete_button": "Supprimer",
      "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce département ?",
      "no_departments": "Aucun département n'a encore été créé."
    },
    "locations": {
      "title": "Lieux",
      "subtitle": "Gérer les emplacements des bureaux et leurs calendriers de congés",
      "add_button": "Ajouter un lieu",
      "name_label": "Nom du lieu",
      "country_label": "Pays",
      "timezone_label": "Fuseau horaire",
      "edit_button": "Modifier",
      "delete_button": "Supprimer",
      "no_locations": "Aucun lieu créé pour le moment"
    },
    "holidays": {
      "title": "Jours fériés",
      "subtitle": "Gérer les jours fériés pour chaque lieu",
      "add_button": "Ajouter un jour férié",
      "location_label": "Emplacement",
      "all_locations": "Tous les emplacements",
      "year_label": "Année",
      "name_label": "Nom du jour férié",
      "date_label": "Date",
      "half_day_label": "Demi-journée",
      "edit_button": "Modifier",
      "delete_button": "Supprimer",
      "no_holidays": "Aucun jour férié pour ce lieu et cette année.",
      "import_button": "Importer les jours fériés"
    },
    "leave_types": {
      "title": "Types de congés",
      "subtitle": "Configurer les types de congés et les droits à congés",
      "add_button": "Ajouter un type de congé",
      "name_label": "Nom",
      "color_label": "Couleur",
      "unit_label": "Unité",
      "unit": {
        "days": "Jours",
        "hours": "Heures"
      },
      "entitlement_label": "Droit par défaut",
      "unlimited": "Illimité",
      "requires_approval_label": "Nécessite une approbation",
      "allow_half_day_label": "Prévoir une demi-journée",
      "is_paid_label": "congé payé",
      "carryover_label": "Report maximal",
      "priority_label": "Priorité",
      "edit_button": "Modifier",
      "delete_button": "Supprimer",
      "no_leave_types": "Aucun type de congé configuré"
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Configurez le mode et le moment d'envoi des notifications.",
      "slack_channel_label": "Canal Slack",
      "email_notifications_label": "Notifications par e-mail",
      "daily_digest_label": "Résumé quotidien",
      "weekly_summary_label": "Résumé hebdomadaire",
      "save_button": "Enregistrer les paramètres"
    },
    "integrations": {
      "title": "Intégrations",
      "subtitle": "Connectez vos outils RH et vos calendriers",
      "connect_button": "Connecter",
      "disconnect_button": "Déconnecter",
      "sync_button": "Synchroniser maintenant",
      "view_logs_button": "Consulter les journaux",
      "last_sync": "Dernière synchronisation : {date}",
      "never_synced": "Jamais synchronisé",
      "status": {
        "connected": "Connecté",
        "disconnected": "Non connecté",
        "error": "Erreur"
      }
    },
    "data": {
      "title": "Gestion des données",
      "subtitle": "Sauvegardez vos données ou effacez les informations de votre espace de travail",
      "current_data": "Données actuelles",
      "total_users": "Nombre total d'utilisateurs",
      "admins": "Administrateurs",
      "regular_users": "Utilisateurs réguliers",
      "leave_requests": "Demandes de congé",
      "backup": {
        "title": "Télécharger la sauvegarde",
        "description": "Téléchargez une sauvegarde complète des données de votre espace de travail au format JSON.",
        "button": "Télécharger la sauvegarde"
      },
      "google_drive": {
        "title": "Sauvegarde Google Drive",
        "description": "Sauvegardes quotidiennes automatiques sur Google Drive.",
        "connect_button": "Connecter Google Drive",
        "folder_label": "Dossier de sauvegarde",
        "auto_backup_label": "Activer la sauvegarde quotidienne automatique",
        "backup_now_button": "Sauvegarder maintenant",
        "last_backup": "Dernière sauvegarde : {date}",
        "upgrade_message": "La sauvegarde quotidienne automatique sur Google Drive est disponible avec le forfait Business."
      },
      "clear_users": {
        "title": "Effacer les utilisateurs non administrateurs",
        "description": "Supprimez tous les utilisateurs à l'exception des administrateurs et des propriétaires. Cette opération supprimera {count} utilisateurs, leurs soldes de congés et toutes les demandes de congés en attente.",
        "warning": "Attention : cette action est irréversible. Assurez-vous de télécharger une sauvegarde au préalable.",
        "confirm_prompt": "Tapez SUPPR pour confirmer",
        "confirm_description": "Cela supprimera définitivement {count} utilisateurs et toutes leurs données.",
        "button": "Effacer les utilisateurs non administrateurs",
        "confirm_button": "Confirmer la suppression des utilisateurs"
      },
      "clear_history": {
        "title": "Effacer l'historique des congés",
        "description": "Supprimer toutes les demandes de congés et remettre à zéro tous les soldes de congés. Cela supprimera {count} demandes de congés.",
        "warning": "Attention : cette action est irréversible. L'historique de vos congés sera définitivement supprimé et votre solde réinitialisé.",
        "confirm_description": "Cette opération supprimera définitivement {count} demandes de congés et réinitialisera tous les soldes.",
        "button": "Effacer l'historique des congés",
        "confirm_button": "Confirmer Effacer l'historique"
      },
      "restore": {
        "title": "Restaurer à partir d'une sauvegarde",
        "description": "Téléversez un fichier JSON de sauvegarde pour restaurer les données de votre espace de travail. Ce fichier remplacera toutes les données existantes.",
        "warning": "Avertissement : La restauration remplacera tous les utilisateurs, types de congés, demandes de congés, services et soldes actuels. Seul le propriétaire de l'espace de travail peut effectuer cette action.",
        "select_file": "Sélectionner le fichier de sauvegarde",
        "backup_details": "Détails de la sauvegarde",
        "file": "Déposer",
        "version": "Version",
        "created": "Créé",
        "confirm_prompt": "Tapez RESTORE pour confirmer",
        "confirm_description": "Cela remplacera définitivement toutes les données existantes par la sauvegarde.",
        "button": "Confirmer la restauration",
        "restoring": "Restauration...",
        "success": "Restauration terminée avec succès !"
      }
    }
  },
  "audit": {
    "page_title": "Piste d'audit",
    "page_subtitle": "Afficher toutes les modifications apportées à votre espace de travail",
    "super_admin_label": "(Super Administrateur)",
    "entries_count": "nombre total d'entrées",
    "filter": {
      "action_label": "Type d'action",
      "all_actions": "Toutes les actions",
      "entity_label": "Type d'entité",
      "all_entities": "Toutes les entités",
      "user_label": "Modifié par",
      "all_users": "Tous les utilisateurs"
    },
    "action": {
      "user_updated": "Mise à jour par l'utilisateur",
      "user_deleted": "Utilisateur supprimé",
      "user_imported": "Importé par l'utilisateur",
      "leave_requested": "Demande de congé",
      "leave_approved": "Congé approuvé",
      "leave_rejected": "Demande de congé refusée",
      "leave_cancelled": "Congé annulé",
      "leave_type_created": "Type de congé créé",
      "leave_type_updated": "Type de congé mis à jour",
      "leave_type_deleted": "Type de congé supprimé",
      "balance_adjusted": "Solde ajusté",
      "department_created": "Département créé",
      "department_updated": "Mise à jour du département",
      "department_deleted": "Département supprimé",
      "audit_log_deleted": "Journal d'audit supprimé"
    },
    "table": {
      "date": "Date",
      "user": "Utilisateur",
      "action": "Action",
      "entity": "Entité",
      "details": "Détails"
    },
    "no_entries": "Aucune entrée de journal d'audit trouvée"
  },
  "billing": {
    "page_title": "Facturation et abonnement",
    "page_subtitle": "Gérez votre abonnement et vos informations de facturation",
    "access_denied": {
      "title": "Accès refusé",
      "message": "Seul le propriétaire de l'espace de travail peut consulter et gérer la facturation.",
      "button": "Retour au tableau de bord"
    },
    "current_plan": {
      "title": "Plan actuel"
    },
    "status": {
      "none": "Aucun abonnement"
    },
    "discount_badge": "{pourcent}% de réduction appliquée",
    "trial_info": {
      "title": "Le procès se termine le {date}",
      "days_remaining": "{jours} jours restants"
    },
    "renewal_info": {
      "title": "Prochaine date de facturation"
    },
    "action": {
      "upgrade": "Passez à la version Pro",
      "view_plans": "Voir tous les forfaits",
      "manage": "Gérer mon abonnement"
    },
    "plan": {
      "trial": "Essai gratuit",
      "free": "Gratuit",
      "pro": "Pro",
      "business": "Entreprise"
    },
    "feature": {
      "up_to_5_users": "Jusqu'à 5 utilisateurs",
      "up_to_50_users": "Jusqu'à 50 utilisateurs",
      "unlimited_users": "Utilisateurs illimités",
      "basic": "Fonctionnalités de base",
      "trial_14days": "Essai de 14 jours",
      "unlimited_requests": "Demandes de congé illimitées",
      "slack_integration": "Intégration Slack",
      "planner": "Vue du planificateur",
      "custom_leave_types": "types de congés personnalisés",
      "approval_workflows": "Flux d'approbation",
      "priority_support": "Soutien prioritaire",
      "multi_team": "Soutien multi-équipes",
      "analytics": "Analyses avancées",
      "api_access": "accès API",
      "dedicated_support": "Soutien dédié"
    }
  },
  "upgrade": {
    "page_title": "Choisissez votre forfait",
    "page_subtitle": "Tarification simple et transparente. Aucun frais par utilisateur.",
    "plan_badge": "Les plus populaires",
    "period": {
      "month": "/mois",
      "year": "/année"
    },
    "yearly_savings": "ou EUR {annuel}/an (économiser {pourcentage}%)",
    "loading": "Chargement des plans...",
    "guarantee": {
      "title": "Garantie de remboursement de 30 jours",
      "description": "Pas satisfait ? Obtenez un remboursement intégral, sans aucune question."
    },
    "faq": {
      "title": "Foire aux questions",
      "q1": "Puis-je modifier mes plans plus tard ?",
      "a1": "Oui, vous pouvez passer à une version supérieure ou inférieure à tout moment. Les modifications sont prises en compte immédiatement et calculées au prorata.",
      "q2": "Quels modes de paiement acceptez-vous ?",
      "a2": "Nous acceptons toutes les principales cartes de crédit (Visa, Mastercard, American Express) via notre prestataire de paiement sécurisé Stripe.",
      "q3": "Existe-t-il un contrat ou un engagement ?",
      "a3": "Non, tous les forfaits sont sans engagement. Vous pouvez résilier à tout moment sans frais.",
      "q4": "Que se passe-t-il lorsque j'atteins ma limite d'utilisateurs ?",
      "a4": "Vous serez invité à passer à un forfait supérieur. Les utilisateurs actuels conserveront leur accès."
    },
    "contact_note": "Vous avez des questions ? Contactez-nous à",
    "current_plan_badge": "Plan actuel",
    "button": {
      "upgrade": "Passez à {plan}",
      "start_trial": "Essai gratuit"
    }
  },
  "login": {
    "processing_title": "Connexion en cours...",
    "processing_message": "Veuillez patienter pendant que nous vérifions vos identifiants auprès de Slack.",
    "subtitle": "Gérez facilement les demandes de congés de votre équipe",
    "slack_button": "Ajouter à Slack",
    "existing_user_text": "Vous utilisez déjà Unplug ?",
    "existing_user_info": "Ouvrez l'application dans Slack et cliquez sur « Tableau de bord d'administration » pour vous connecter.",
    "terms_text": "En continuant",
    "error": {
      "workspace_not_found": "Espace de travail introuvable. Veuillez vérifier l'URL.",
      "invalid_response": "Réponse invalide du serveur",
      "generic": "La connexion a échoué",
      "please_retry": "Échec de la connexion. Veuillez réessayer."
    }
  },
  "help": {
    "page_title": "Centre d'aide",
    "page_subtitle": "Trouvez des réponses et apprenez à utiliser Unplug",
    "action": {
      "restart_tour": "Tournée de redémarrage"
    },
    "search": {
      "placeholder": "Consultez les articles d'aide, la FAQ...",
      "results": "Articles et FAQ trouvés correspondant à « {query} »"
    },
    "quick_link": {
      "getting_started": "Commencer",
      "faqs": "FAQ",
      "contact_support": "Contacter l'assistance",
      "tour": "Faites la visite"
    }
  },
  "profile": {
    "page_title": "Paramètres du profil",
    "personal_info": "Informations personnelles",
    "name_label": "Nom et prénom",
    "email_label": "E-mail",
    "department_label": "Département",
    "location_label": "Emplacement",
    "manager_label": "Directeur",
    "start_date_label": "Date de début",
    "save_button": "Enregistrer les modifications",
    "preferences": "Préférences",
    "language_label": "Langue",
    "timezone_label": "Fuseau horaire"
  },
  "planner": {
    "page_title": "Planificateur",
    "page_subtitle": "Calendrier visuel de l'équipe montrant toutes les absences",
    "feature_name": "Planificateur",
    "feature_description": "Calendrier visuel de l'équipe montrant toutes les absences en un coup d'œil",
    "empty_state": "Aucun membre de l'équipe trouvé",
    "filter": {
      "pending_request": "Demande en attente",
      "filter_by": "Filtrer par",
      "department": "Département",
      "all_departments": "Tous les départements",
      "location": "Emplacement",
      "all_locations": "Tous les emplacements"
    },
    "export": {
      "button": "Exporter",
      "title": "Exporter les données de congés",
      "format": "Format d'export",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "CSV générique",
      "date_range": "Plage de dates",
      "departments": "Départements"
    },
    "legend": {
      "approved": "Approuvé",
      "pending": "En attente",
      "holiday": "Jour férié",
      "holidays": "Jours fériés",
      "weekend": "Week-end",
      "non_working": "Jour non travaillé",
      "partial_day": "Absences inférieures à une journée"
    },
    "no_data": "Aucune absence à afficher"
  },
  "error": {
    "network": "Erreur réseau. Veuillez vérifier votre connexion.",
    "unauthorized": "Vous n'êtes pas autorisé à effectuer cette action.",
    "not_found": "La ressource demandée est introuvable.",
    "server": "Erreur serveur. Veuillez réessayer plus tard.",
    "validation": "Veuillez vérifier le formulaire pour détecter d'éventuelles erreurs.",
    "generic": "Une erreur s'est produite. Veuillez réessayer.",
    "session_expired": "Votre session a expiré. Veuillez vous reconnecter."
  },
  "success": {
    "saved": "Modifications enregistrées avec succès.",
    "deleted": "Supprimé avec succès.",
    "created": "Créé avec succès.",
    "updated": "Mise à jour réussie.",
    "submitted": "Soumis avec succès.",
    "sent": "Envoi réussi."
  },
  "weekday": {
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Épouser",
    "thu": "Jeu",
    "fri": "Ven",
    "sat": "Assis",
    "sun": "Soleil"
  },
  "month": {
    "january": "Janvier",
    "february": "Février",
    "march": "Mars",
    "april": "Avril",
    "may": "Peut",
    "june": "Juin",
    "july": "Juillet",
    "august": "Août",
    "september": "Septembre",
    "october": "Octobre",
    "november": "Novembre",
    "december": "Décembre",
    "jan": "Jan",
    "feb": "Fév",
    "mar": "Mar",
    "apr": "Avr",
    "may_short": "Peut",
    "jun": "Juin",
    "jul": "Juillet",
    "aug": "Août",
    "sep": "Sep",
    "oct": "Octobre",
    "nov": "Nov",
    "dec": "Déc"
  },
  "language": {
    "en": "Anglais",
    "es": "Espagnol",
    "fr": "Français",
    "de": "Allemand",
    "it": "italien",
    "pt": "portugais",
    "pl": "polonais",
    "nl": "Néerlandais",
    "sv": "suédois",
    "no": "norvégien"
  },
  "leave_type_name": {
    "Vacation": "Vacances",
    "Vacation Leave": "Congés payés",
    "Annual Leave": "Congés annuels",
    "Unpaid Vacation": "Congés sans solde",
    "Unpaid Leave": "Congé sans solde",
    "Sick Leave": "Arrêt maladie",
    "Sick Leave (Full Pay)": "Arrêt maladie (salaire complet)",
    "Maternity Leave": "Congé maternité",
    "Paternity Leave": "Congé paternité",
    "Parental Leave": "Congé parental",
    "Bereavement Leave": "Congé décès",
    "Marriage Leave": "Congé mariage",
    "Jury Leave": "Congé jury",
    "Jury Duty": "Service de jury",
    "Work Travel": "Déplacement professionnel",
    "Working Remotely": "Télétravail",
    "Remote Work": "Télétravail",
    "Work From Home": "Travail à domicile",
    "Personal Day": "Jour personnel",
    "TOIL": "Récupération",
    "Time Off In Lieu": "Récupération",
    "Compassionate Leave": "Congé pour raisons personnelles",
    "Study Leave": "Congé formation",
    "Training": "Formation",
    "Public Holiday": "Jour férié"
  }
}
